import {
  FiGitBranch, FiCloud, FiActivity, FiDollarSign, FiCpu,
  FiLayers, FiShield, FiTerminal, FiZap, FiDatabase, FiBox,
} from "react-icons/fi";

const SERVICES = [
  {
    icon: FiTerminal,
    title: "DevOps Engineering",
    text: "End-to-end DevOps practice: workflow design, automation, developer experience, and operational excellence baked into every release.",
  },
  {
    icon: FiGitBranch,
    title: "CI/CD Pipelines",
    text: "Reliable pipelines on GitHub Actions, GitLab, Jenkins, or ArgoCD with automated testing, security scans, blue-green & canary deploys.",
  },
  {
    icon: FiCloud,
    title: "Cloud Providers",
    text: "AWS, GCP, Azure & private cloud (VMware) architectures designed for scale, resilience and cost - multi-region and multi-account ready.",
  },
  {
    icon: FiActivity,
    title: "Monitoring & Observability",
    text: "Prometheus, Grafana, Datadog, OpenTelemetry - full-stack metrics, logs, traces and SLO-driven alerting that wakes the right person.",
  },
  {
    icon: FiLayers,
    title: "Infrastructure as Code",
    text: "Terraform, Pulumi, Crossplane & Ansible modules with policy-as-code, drift detection and reusable building blocks for every team.",
  },
  {
    icon: FiDollarSign,
    title: "FinOps & Cost Optimization",
    text: "Cloud spend visibility, rightsizing, savings plans, and automated guardrails. We commit to ROI you can put on a slide.",
  },
  {
    icon: FiBox,
    title: "Microservices & Kubernetes",
    text: "Kubernetes platforms, service mesh, GitOps and progressive delivery - split monoliths cleanly without breaking the business.",
  },
  {
    icon: FiCpu,
    title: "AI & Agent Systems",
    text: "LLM apps, RAG pipelines, and autonomous agents wired into your stack. MLOps, vector DBs, evaluations, and safe production rollout.",
  },
  {
    icon: FiShield,
    title: "DevSecOps",
    text: "Shift-left security: SAST, DAST, secret scanning, SBOMs, runtime policy with OPA & Kyverno, plus compliance automation (SOC2, ISO).",
  },
  {
    icon: FiZap,
    title: "Platform Engineering",
    text: "Internal developer platforms (Backstage, golden paths, self-service portals) that turn ops bottlenecks into one-click workflows.",
  },
  {
    icon: FiDatabase,
    title: "Data & MLOps",
    text: "Reliable data platforms, feature stores, model training & serving pipelines, and reproducible ML environments end to end.",
  },
  {
    icon: FiCpu,
    title: "Architecture & Migration",
    text: "Cloud migrations, modernization plans, and reference architectures designed around your real constraints - not hype.",
  },
];

export default function Services() {
  return (
    <section id="services" className="section">
      <div className="container">
        <div className="section__head">
          <span className="section__eyebrow">What we deliver</span>
          <h2 className="section__title">Services built for modern engineering teams</h2>
          <p className="section__lead">
            A single team that owns the full lifecycle - from architecture and
            automation to AI integration, observability, and cost.
          </p>
        </div>

        <div className="services-grid">
          {SERVICES.map(({ icon: Icon, title, text }) => (
            <article key={title} className="service-card">
              <div className="service-card__icon">
                <Icon />
              </div>
              <h3 className="service-card__title">{title}</h3>
              <p className="service-card__text">{text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
